export enum SocialHistoryRadioGroupId {
  CONDITION = 337373
}

export enum SocialHistoryRadioGroupExpressions {
  CONDITION = 'condition'
}

export enum SocialHistoryConditionId {
  MILD_LITTLE          = 'L',
  MEDIUM_MODERATE      = 'M',
  SEVERE_LARGE         = 'I',
}
